import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [moduleTitle, setModuleTitle] = useState('Portal Principal');
  const [activeTab, setActiveTab] = useState('recepcion');
  const [subOptions, setSubOptions] = useState([]);
  const [activeItemTitle, setActiveItemTitle] = useState('');
  
  // Metricas Globales para la barra de estado inferior
  const [globalStats, setGlobalStats] = useState({
    totalPacientes: 0,
    totalPesos: 0,
    totalAtendidos: 0,
    totalFacturado: 0,
    enRegistro: 0,
    enEspera: 0,
    enEstudio: 0,
    finalizados: 0,
    progressPct: 0,
    stationId: '',
  });

  // Fecha y sincronización compartidas
  const getLocalDateString = () => {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Tijuana',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());
  };
  
  const [selectedDate, setSelectedDate] = useState(getLocalDateString());
  const [syncing, setSyncing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [syncTrigger, setSyncTrigger] = useState(0);

  const triggerSync = () => {
    setSyncTrigger(prev => prev + 1);
  };

  // Detección de dispositivos móviles de forma limpia y eficiente
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia('(max-width: 768px)').matches;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handleMediaChange = (e) => {
      setIsMobile(e.matches);
    };
    
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleMediaChange);
      return () => mediaQuery.removeEventListener('change', handleMediaChange);
    } else {
      mediaQuery.addListener(handleMediaChange);
      return () => mediaQuery.removeListener(handleMediaChange);
    }
  }, []);

  return (
    <AppContext.Provider
      value={{
        moduleTitle,
        setModuleTitle,
        activeTab,
        setActiveTab,
        subOptions,
        setSubOptions,
        activeItemTitle,
        setActiveItemTitle,
        globalStats,
        setGlobalStats,
        selectedDate,
        setSelectedDate,
        syncing,
        setSyncing,
        loading,
        setLoading,
        syncTrigger,
        triggerSync,
        isMobile,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
